exports = module.exports = require("../../../node_modules/_css-loader@0.28.7@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".code {\n  width: 90px;\n  height: 45px;\n}\n.code .code-getcode {\n  line-height: 45px;\n  text-align: center;\n  background: #FE9D04;\n  color: #ffffff;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.code .code-disabled {\n  font-size: 12px;\n  background: #cccccc;\n  cursor: not-allowed;\n  border-radius: 8px;\n  outline: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.7@css-loader?{"importLoaders":1}!./node_modules/_postcss-loader@2.0.8@postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/_less-loader@4.1.0@less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/codeBtn/index.less
// module id = 503
// module chunks = 0